/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createCustomerSystemTicketNumberPlugin',
    message: messages.SUCCESS_CREATE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
    method: 'POST',
    path: '/customer/:customerId/system-ticket-number-plugin',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
    requestSchema: requestSchemas.customerSystemTicketNumberPlugins.createCustomerSystemTicketNumberPlugin,
  },
  {
    action: 'deleteCustomerSystemTicketNumberPlugins',
    message: messages.SUCCESS_DELETE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS,
    method: 'DELETE',
    path: '/customer/:customerId/system-ticket-number-plugins',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
    requestSchema: requestSchemas.customerSystemTicketNumberPlugins.deleteCustomerSystemTicketNumberPlugins,
  },
  {
    action: 'getCustomerSystemTicketNumberPlugins',
    message: messages.SUCCESS_GET_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS,
    method: 'GET',
    path: '/customer/:customerId/system-ticket-number-plugins',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGIN,
    requestSchema: requestSchemas.customerSystemTicketNumberPlugins.getCustomerSystemTicketNumberPlugins,
    scopes: [
      scopes.CUSTOMER_SYSTEM_TICKET_NUMBER_PLUGINS_INPUT,
      scopes.DEFAULT,
    ],
  },
];
